<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48.0545 50C47.0389 50 46.2029 49.2221 46.118 48.2154C45.7565 43.9196 44.2049 40.0384 41.3758 36.6477C37.8052 32.3702 33.2388 29.7624 27.658 29.0946C21.2067 28.3227 15.53 30.1184 10.7151 34.4656C6.76592 38.0299 4.52942 42.4958 3.91343 47.7603C3.89499 47.9132 3.88146 48.0661 3.8704 48.219C3.7954 49.2233 2.95072 49.9988 1.93882 49.9988C0.802741 49.9988 -0.0898924 49.0312 0.00723989 47.9047C0.0834703 47.0252 0.178144 46.1091 0.259292 45.6467C1.18635 40.387 3.59499 35.8955 7.41019 32.1513C9.98358 29.6254 12.975 27.7429 16.3759 26.51C16.4792 26.4721 16.5775 26.4195 16.7214 26.3546C12.6271 23.2893 10.425 19.281 10.4914 14.1827C10.543 10.2624 12.0234 6.88276 14.8414 4.14527C20.78 -1.62204 29.8822 -1.19515 35.3597 4.3312C41.4643 10.4899 40.9024 21.1121 33.3777 26.2959C43.1967 30.4853 48.9803 37.5125 49.991 47.8937C50.1004 49.0239 49.1967 49.9976 48.057 49.9976L48.0545 50ZM25.0047 3.90431C19.189 3.89575 14.4258 8.61479 14.3951 14.4164C14.3644 20.2118 19.146 24.9871 24.9862 24.9957C30.8019 25.0042 35.565 20.2852 35.5958 14.4836C35.6265 8.68818 30.8449 3.91287 25.0047 3.90431Z"
      fill="#F45484"
    />
  </svg>
</template>
  
<script>
export default {
  name: "PersonIcon",
};
</script>